import React from 'react'
import { DragDropContainer } from './plugin'
import styles from './DraggableCard.module.css'
import classNames from 'classnames/bind'

const cx = classNames.bind(styles)

const Icon = props => <div />

const DraggableCard = props => (
  <div className={cx({
    'draggable-item-el': true,
    base: true,
    dropped: props.data.dropped,
    correct: props.submitted && props.data.correct,
    wrong: props.submitted && !props.data.correct,
  })}>
    <DragDropContainer
      dragData={props.data}
      onDragStart={props.onDragStart}
      onDragEnd={props.onDragEnd}
      onDrop={props.onDrop}
    >
      <div className={`draggable-card-el ${styles.card}`}>
        <div className={`draggable-card-label-el ${styles.cardLabel}`}>
          {props.children}
        </div>
      </div>
    </DragDropContainer>
  </div>
)

const DraggableCards = props => (
  <div className={`draggable-list-el ${styles.list}`}>
    {props.children}
  </div>
)

DraggableCard.defaultProps = {
  data: {},
}

export default DraggableCard
export { DraggableCards }
